// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"styles_responsiveContainer__s856_"};
module.exports.__checksum = "52a1f3cac568"